import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";
import {IFilter} from "../services/IFilter";
import { AuthService } from "../services/auth.service";

export class OsVersionsFilter implements IFilter {
  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService) {
    this.clear();
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(value:any) {
    this.companyIdChange.next(value);
    this.emitChange("companyId", value);
  }

  nameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get name():any {
    return this.nameChange.value;
  }
  set name(value:any) {
    this.nameChange.next(value);
    this.emitChange("name", value);
  }

  descriptionChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get description():any {
    return this.descriptionChange.value;
  }
  set description(value:any) {
    this.descriptionChange.next(value);
    this.emitChange("description", value);
  }

  activeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get active():any {
    return this.activeChange.value;
  }
  set active(value:any) {
    this.activeChange.next(value);
    this.emitChange("active", value);
  }

  osFamilyChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get osFamily():any {
    return this.osFamilyChange.value;
  }
  set osFamily(value:any) {
    this.osFamilyChange.next(value);
    this.emitChange("osFamily", value);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }
    if (this.name && this.name !== '') {
      params = params.set("name", this.name);
    }
    if (this.description && this.description !== '') {
      params = params.set("description", this.description);
    }
    if (this.active && this.active !== '') {
      params = params.set("active", this.active);
    }
    if (this.osFamily && this.osFamily !== '') {
      params = params.set("osFamily", this.osFamily);
    }

    return params;
  }

  setFilters(props: any): void {
    this.companyIdChange.next(props.companyId === undefined ? this.auth.getCompanyId() : props.companyId || undefined);
    this.nameChange.next(props.name || undefined);
    this.descriptionChange.next(props.description || undefined);
    this.activeChange.next(props.active || undefined);
    this.osFamilyChange.next(props.osFamily || undefined);
  }

  toObj() {
    let obj:any = {};
    
    obj.companyId = this.companyId;
    obj.name = this.name;
    obj.description = this.description;
    obj.active = this.active;
    obj.osFamily = this.osFamily;
 
    return obj;
  }

  public clear():void {
    this.companyId = this.auth.getCompanyId();
    this.name = undefined;
    this.description = undefined;
    this.active = undefined;
    this.osFamily = undefined;
  }
}
